<template>
    <div>
        <div class="title_nav">
      <div>
        <Icon @click="$router.replace({ path: '/' })" name="arrow-left" style="margin-top:0.1rem" />
      </div>
      <div class="nav_address"> 公告 </div>
    </div>
        <div style="width: 100%;">
            <pre v-if="type==1">{{ userText }}</pre>
            <pre v-if="type==2">{{ purchaseText }}</pre>
            <pre v-if="type==3">
              
<span class="title">实物商城下单须知：</span>
1.商城商品下单后48小时内(节假日顺延)发货，发货后预计第二日可在订单详情里查看物流单号:产品图片仅供参考，请以实物为准，部分商品新老包装随机发货;
2.因水果生鲜产品的特殊性，保鲜时效有限，不支持拒收，且一经兑换，无质量问题不提供退换货服务;下单前请务必确认收货信息，商品发出后不可中途修改地址，请保持电话通畅及时收货;果蔬生鲜存在差异或有自然瑕疵属于正常现象，例如:果斑，果渍，擦伤(包括但不仅限此类瑕疵)在不影响食用的情况下，不属于赔偿范围;
3.为保障您的权益，请您签收时与配送人员当面核对商品的种类、数量、规格、赠品、金额、保质期等是否正确，请在确认无误后再进行签收。如有问题请及时向配送人员反馈，一旦签收，商城将不受理此类退货、补货等要求;
4.配送范围:全国配送(青海、宁夏、西藏、新疆、广西、海南、内蒙古、港澳台及其他偏远地区除外)，个别商品例外，具体可配送范围请以下单为准。

<span class="title">非实物商城下单须知：</span>
1.电影/旅游/会员直冲等订单为自动出票，下单前请核实订单信息，下单后无法退款操作，请谨慎下单；
2.请规范下单行为，切勿刷单、倒卖、非正常用户下单等，一经发现有权冻结异常账户；
3.系统综合判定为异常用户将被锁定，需开具单位证明说明情况后方可解除。
            </pre>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vant';
export default {
    components:{
        Icon
    },
    data() {
        return {
            userText: `
              使用协议	
一、服务协议的确定
《服务条款》(以下简称"本条款")由北京小将文化有限公司在提供域名为xiaojiangwh.com小将文化的网站服务时与小将文化用户达成的关于使用小将文化的各项规则、条款和条件。用户点击"同意"选项完成注册，这表示用户已接受本服务条款，并与公司就本服务条款达成协议。
二、内容所有权
1、小将文化提供的网络服务内容可能包括:文字、软件、声音、图片、录象、图表等。所有这些内容受版权、商标和其它财产所有权法律的保护。
2、用户只有在获得小将文化或其他相关权利人的授权之后才能使用这些内容，而不能擅自复制、再造这些内容、或创造与这些内容有关的派生产品。
三、用户信息的提供
为保障用户的合法权益，避免在服务时因用户注册资料与真实情况不符而发生纠纷，请用户注册时务必按照真实、全面、准确的原则填写。对因用户自身原因而造成的不能服务情况，用户需承担相应责任。如果用户提供的资料包含有不正确的信息，小将文化保留结束该用户使用服务资格的权利。
四、用户资料隐私保护
1、本协议所称之用户隐私包括被法律确认为隐私内容，并符合下述范围的信息:
(a)用户注册小将文化时根据网站要求提供的个人信息:
(b)在用户使用小将文化服务、参加网站活动、或访问网站网页时，网站自动接收并记录的用户浏览器上的服务器数据，包括但不限干IP地址、网站Cookie中的资料及用户要求取用的网页记录:
(c)小将文化通过合法途径从商业伙伴处取得的用户个人资料。
2、保护用户隐私是小将文化的一项基本政策，小将文化保证不对外公开或向第三方提供用户注册资料及用户在使用网络服务时存储在小将文化的非公开内容，但下列情况除外:
(a)事先获得用户的明确授权:
(b)根据有关的法律法规要求:
(c)按照相关政府主管部门的要求;
(d)为维护社会公众的利益;
(e)为维护小将文化的合法权益。
3、小将文化可能会与第三方合作向用户提供相关服务，在此情况下，如该第三方同意承担与小将文化同等的保护用户隐私的责任，则小将文化可将用户的注册资料等信息提供给该第三方。在不透露单个用户隐私资料的前提下，小将文化有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
5、用户须做到
(a)用户名和昵称的注册与使用应符合网络道德，遵守中华人民共和国的相关法律法规;
(b)用户名和昵称中不能含有威胁、淫秽、漫骂、非法、侵害他人权益等有争议性的文字。
五、用户资料安全
1、对用户注册信息小将文化提供最大限度的安全保障。同时，用户务必对其用户密码、个人账号等信息保密，以免被盗用或遭窑改。注册成功后，用户必须保护好自己的账号和密码，
              `,
              purchaseText:`
              购买须知
1.商城商品下单后48小时内(节假日顺延)发货，发货后预计第二日可在订单详情里查看物流单号
2.产品图片仅供参考，请以实物为准，部分商品新老包装随机发货
3.因水果生鲜产品的特殊性，保鲜时效有限，不支持拒收，且一经兑换，无质量问题不提供退换货服务;下单前请务必确认收货信息，商品发出后不可中途修改地址，请保持电话通畅及时收货:果蔬生鲜存在差异或有自然瑕疵属干正常现象，例如:果斑，果渍，擦伤(包括但不仅限此类瑕疵)在不影响食用的情况下，不属于赔偿范围
4为保障您的权益，请您签收时与配送人员当面核对商品的种类、数量、规格、赠品、金额、保质期等是否正确，请在确认无误后再进行签收。如有问题请及时向配送人员反馈，一旦签收，商城将不受理此类退货、补货等要求
5.配送范围:全国配送(青海、宁夏、西藏、新疆、广西、海南、内蒙古、港澳台及其他偏远地区除外)，个别商品例外，具体可配送范围请以下单页面可选择地址为准
6.查看7天无理由退换规范
              `,
   ScrollMessage:`

                `,
              type:1,
        }
    },
    mounted () {
        this.type=this.$route.query.type
    }
}
</script>

<style lang="scss" scoped>
pre{
    white-space: pre-wrap;
        word-wrap: break-word;
        font-size: 0.3rem;
}
pre .title{
  font-weight: bold;
}
.title_nav {
  display: flex;
  width: 100%;
  background: white;
  height: 0.7rem;
  padding-left: 0.2rem;
  padding-top: 0.15rem;
}

.nav_address {
  width: 80%;
  text-align: center;
  margin-left: 0.4rem;
  padding-top: 0.05rem;
}
</style>